import { useMediaToQualifyFiltersStore } from '../stores/mediaToQualifyFiltersStore';

export const useMediaToQualifyFilters = () => {
  const filters = useMediaToQualifyFiltersStore((state) => state.filters);
  const setFilters = useMediaToQualifyFiltersStore((state) => state.setFilters);
  const updateFilters = useMediaToQualifyFiltersStore(
    (state) => state.updateFilters
  );
  const setFilter = useMediaToQualifyFiltersStore((state) => state.setFilter);
  const removeFilter = useMediaToQualifyFiltersStore(
    (state) => state.removeFilter
  );
  const clearFilters = useMediaToQualifyFiltersStore(
    (state) => state.clearFilters
  );
  const getFilter = useMediaToQualifyFiltersStore((state) => state.getFilter);
  const hasFilters = useMediaToQualifyFiltersStore((state) =>
    state.hasFilters()
  );
  const hasFilter = useMediaToQualifyFiltersStore((state) => state.hasFilter);

  const setSelectedStatusIdFilter = (value) =>
    setFilter('selectedStatusId', value);
  const setSelectedTypeFilter = (value) => setFilter('selectedType', value);
  const setSelectedTagsFilter = (value) => setFilter('selectedTags', value);
  const setSelectedMediaFormatFilter = (value) =>
    setFilter('selectedMediaFormat', value);
  const setSelectedOrderFilter = (value) => setFilter('selectedOrder', value);
  const setSelectedCategoryNameFilter = (value) =>
    setFilter('selectedCategoryName', value);
  const setSelectedDimensionsFilter = (value) =>
    setFilter('selectedDimensions', value);
  const setSelectedSizesFilter = (value) => setFilter('selectedSizes', value);
  const setSelectedResolutionsFilter = (value) =>
    setFilter('selectedResolutions', value);
  const setSelectedCreatedAtFilter = (value) =>
    setFilter('selectedCreatedAt', value);

  return {
    filters,
    setFilters,
    updateFilters,
    setFilter,
    removeFilter,
    clearFilters,
    getFilter,
    hasFilters,
    hasFilter,
    setSelectedStatusIdFilter,
    setSelectedTypeFilter,
    setSelectedTagsFilter,
    setSelectedMediaFormatFilter,
    setSelectedOrderFilter,
    setSelectedCategoryNameFilter,
    setSelectedDimensionsFilter,
    setSelectedSizesFilter,
    setSelectedResolutionsFilter,
    setSelectedCreatedAtFilter,
  };
};
